export default {
	
	showJobSeekerRegistered: [],
	analytics:{
		employer:[],
		jobseeker:[],
		employerJobseeker:[],
		jobfairAdvertisementReferral:[],
	}
}